export enum SpamScenarioId {
    BlockedSendersAndDomains = 1, // Option scenario for blocked senders and domains spam setting
    SafeSendersAndDomains = 2, // Option scenario for safe senders or domains spam setting
    SafeMailingLists = 3,
}

export default SpamScenarioId;
